import styled from 'styled-components';

export const WrapperStyled = styled.div`
  max-width: 80vw;
  margin: 0 auto;
`;
